module.exports = __webpack_public_path__ + "static/img/saas2H5.d0fb272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saas2H5.png
// module id = iS+B
// module chunks = 1